import { alpacaRecycleBoxABI } from '@/utils/abi';

export const contractOldAddress = process.env.VUE_APP_ALPACA_RECYCLE_BOX_CONTRACT_OLD_ADDRESS;
export const contractAddress = process.env.VUE_APP_ALPACA_RECYCLE_BOX_CONTRACT_ADDRESS;

let contractOld: any = null;
let contract: any = null;

export const initContract = () => {
  if (window.web3 && contract === null) {
    contract = new window.web3.eth.Contract(alpacaRecycleBoxABI, contractAddress);
    contractOld = new window.web3.eth.Contract(alpacaRecycleBoxABI, contractOldAddress);
  }
};

export const totalRecycledAlpaca = async () => {
  initContract();
  try {
    const amount = await contract.methods.totalRecycledAlpaca().call();
    const amountOld = await contractOld.methods.totalRecycledAlpaca().call();
    return String(Number(amount) + Number(amountOld));
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const totalMintedWool = async () => {
  initContract();
  try {
    const amount = await contract.methods.totalMintedWool().call();
    const amountOld = await contractOld.methods.totalMintedWool().call();
    return window.web3.utils.fromWei(amount, 'ether') + window.web3.utils.fromWei(amountOld, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};
